import { render, staticRenderFns } from "./NewsFeedAction.vue?vue&type=template&id=1133ac26&scoped=true&"
import script from "./NewsFeedAction.vue?vue&type=script&lang=js&"
export * from "./NewsFeedAction.vue?vue&type=script&lang=js&"
import style0 from "./NewsFeedAction.vue?vue&type=style&index=0&id=1133ac26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1133ac26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSpeedDial,VTooltip})
